import React, { useMemo } from "react";

import {
  FilterGroup,
  FilterGroupOnChange,
} from "@/common/components/filters/FilterGroup";
import { CompaniesColumn } from "@reflag/shared/companyAPI";
import {
  FilterGroup as FilterGroupModel,
  UIFilter,
  UIFilterType,
  wrapWithFilterGroup,
} from "@reflag/shared/filter";
import { ColumnState } from "@reflag/shared/types/columns";
import { UsersSortByColumn } from "@reflag/shared/userAPI";

type ColumnId = CompaniesColumn | UsersSortByColumn;

type Props<TColumn extends string = ColumnId> = {
  columnStates: ColumnState<TColumn>[];
  filter: UIFilter;
  onFilterChange: FilterGroupOnChange;
};

export function SegmentFilters<TColumn extends string = ColumnId>({
  filter,
  onFilterChange,
}: Props<TColumn>) {
  const rootFilter = useMemo<FilterGroupModel<UIFilter>>(
    () => wrapWithFilterGroup(filter),
    [filter],
  );

  const types: UIFilterType[] = [
    "companyAttribute",
    "segment",
    "featureMetric",
    "featureTargeting",
    "companyIds",
    "userAttribute",
    "userIds",
  ];

  return (
    <FilterGroup
      context="segment"
      types={types}
      value={rootFilter}
      flatten
      onChange={onFilterChange}
    />
  );
}
